import {
  LoginResponse,
  EnviarTokenSenhaRequest,
  AlterarSenhaRequest,
  LoginRequest,
  GenericActionResponse,
  VerificarTokenResponse,
  VerificarTokenRequest,
  LoginResponseType,
} from "../@types";
import apiAutenticacao from "./api-autenticacao.service";
import { Token, NomeCompleto, ItemsMenu } from "../utils/localStorage.util";

export const AuthServices = {
  login: (loginResponse: LoginResponseType) => {
    Token.setToken(loginResponse.token);
    ItemsMenu.setItemsMenu(
      JSON.stringify(loginResponse.menusPermitidos)
    );
    NomeCompleto.setNomeCompleto(loginResponse.usuario.nomeCompleto);
  },
  logout: () => {
    Token.removeToken();
    NomeCompleto.removeNomeCompleto();
    ItemsMenu.removeItemsMenu();
  }
};

export function authenticationHandler(
  loginRequest: LoginRequest,
): Promise<LoginResponse> {
  return apiAutenticacao.post("/usuarios/autenticar", loginRequest);
}

export function verificarTokenHandler(
  token: VerificarTokenRequest
): Promise<VerificarTokenResponse> {
  return apiAutenticacao.post("/usuarios/verificar-token", token);
}

export function enviarTokenSenhaHandler(
  email: EnviarTokenSenhaRequest
): Promise<GenericActionResponse> {
  return apiAutenticacao.post("/usuarios/enviar-token-senha", email);
}

export function alterarSenhaHandler(
  token: string,
  nova_senha: AlterarSenhaRequest
): Promise<GenericActionResponse> {
  return apiAutenticacao.put(`/usuarios/redefinir-senha/${token}`, nova_senha);
}
